import { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import OutsideClickHandler from 'react-outside-click-handler';

import Input from '../Input';
import type { InputProps } from '../Input';

import styles from './_index.module.scss';

export interface InputColorProps {
  label: InputProps['label'];
  onChange?: (color: string) => void;
  value?: string;
}

const InputColor = ({ label, onChange = () => {}, value = '#00e36b' }: InputColorProps) => {
  const [color, setColor] = useState({ color: value });
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    onChange(color?.color);
  }, [color]);

  return (
    <div className={styles['input-color-wrapper']}>
      <OutsideClickHandler onOutsideClick={() => setIsActive(false)}>
        <div className={styles['input-color-input-wrapper']} onClick={() => setIsActive(!isActive)}>
          <div className={styles['input-color-swatch']}>
            <div style={{ backgroundColor: color?.color }} />
          </div>
          <Input className={styles['input-color-input']} label={label} value={color?.color} />
        </div>
        {isActive && (
          <SketchPicker
            color={color?.color}
            onChange={(updatedColor) => {
              setColor({ color: updatedColor.hex });
            }}
          />
        )}
      </OutsideClickHandler>
    </div>
  );
};

export default InputColor;
